import Skeleton from "react-loading-skeleton";

export function LoadingNotificationBody() {
    return <div className="media new">
        <div>
            <Skeleton width={35} height={35} borderRadius={50} />
        </div>

        <div className="media-body mg-t-10">
            <Skeleton />
        </div>
    </div>
}